module.exports = __webpack_public_path__ + "officialStatic/img/partner.444b9a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/about/partner.png
// module id = iOmC
// module chunks = 0